import { createStore } from '@stencil/store';

// Create the store
const { state } = createStore<Record<string, any>>({});

// Export the state
export const sharedStore = state;
